import {IGenericBooster} from "../../types/booster_generic/IGenericBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IGenericBoostersConfig} from "../../types/IGenericBoostersConfig";

export const getValidBoosterTypesInCategory = <TBoosterPrams extends object>(
    config: IGenericBoostersConfig<TBoosterPrams>,
    selectedCategory: IBoosterCategory,
    params: TBoosterPrams
) => {
    const boostersInCategory = config[selectedCategory];
    if (!boostersInCategory) {
        return [];
    }

    const boosterTypes = Object.keys(boostersInCategory) as (keyof typeof boostersInCategory)[];
    return boosterTypes.filter((type) => {
        const booster = boostersInCategory[type] as IGenericBooster<TBoosterPrams> | undefined;
        return booster && booster.isValid(params);
    });
};
import {IGenericBooster} from "../../types/booster_generic/IGenericBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IGenericBoostersConfig} from "../../types/IGenericBoostersConfig";

export const getValidBoosterTypesInCategory = <TBoosterPrams extends object>(
    config: IGenericBoostersConfig<TBoosterPrams>,
    selectedCategory: IBoosterCategory,
    params: TBoosterPrams
) => {
    const boostersInCategory = config[selectedCategory];
    if (!boostersInCategory) {
        return [];
    }

    const boosterTypes = Object.keys(boostersInCategory) as (keyof typeof boostersInCategory)[];
    return boosterTypes.filter((type) => {
        const booster = boostersInCategory[type] as IGenericBooster<TBoosterPrams> | undefined;
        return booster && booster.isValid(params);
    });
};
